// extracted by mini-css-extract-plugin
export var alwaysShowPropertyIcons = "u6qq3";
export var applyDefaultIconColor = "Suhth";
export var disabledHoverActionCursor = "Ar46p";
export var full = "suvGu";
export var fullV9 = "gAgQE";
export var hoverActionButtonV9 = "FMwEJ";
export var hoverActionIcon = "BXibp";
export var hoverActionIconV9 = "EvY_P";
export var hoverIconInIconBarV9 = "ntvIS";
export var icon = "kElPw";
export var iconBarContainer = "bvdCQ";
export var iconBarLeftMargin = "pY8AN";
export var iconBarNoLeftMargin = "mQaQq";
export var iconContainerNew = "hnzOS";
export var iconDisplay = "Q_UHS";
export var iconDisplayV9 = "iDHxk";
export var iconHide = "W_gAr";
export var iconInIconBar = "pDxoJ";
export var iconInIconBarV9 = "p6VIl";
export var iconNoDisplay = "pPZMd";
export var iconNotSupportedVisibility = "swPrc";
export var iconV9 = "b411r";
export var propertyIcon = "gXxPA";